export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9YHZ5iXwJxArepzhN.3dfd2578.woff2";